import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTableModule } from '@angular/material/table';

import { FormsModule } from '@angular/forms';
import { EmployeeServiceService } from 'src/providers/employee-service/employee-service.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TimeLogsComponent } from './time-logs/time-logs.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthorizationComponent } from './authorization/authorization.component';
import { VoidTimelogComponent } from './void-timelog/void-timelog.component';
import { RequestByComponent } from './request-by/request-by.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import {WebcamModule} from 'ngx-webcam';
import { CameraComponent } from './camera/camera.component';
import { SnapShotComponent } from './snap-shot/snap-shot.component';
import { ExportTimeLogsComponent } from './export-time-logs/export-time-logs.component';
@NgModule({
  declarations: [
    AppComponent,
    TimeLogsComponent,
    AuthorizationComponent,
    VoidTimelogComponent,
    RequestByComponent,
    ConfirmDialogComponent,
    CameraComponent,
    SnapShotComponent,
    ExportTimeLogsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatGridListModule,
    MatTableModule,
    ToastrModule.forRoot(),
    NgbModule,
    NgxSpinnerModule,
    WebcamModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    EmployeeServiceService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
